import { useCallback } from 'react';
import { useConfig } from '@repo/shared-kit/config/config-provider';
import { useQontoWebsocket } from '@repo/shared-kit/websocket/use-websocket';
import { useQontoWebsocketConnection } from '@repo/shared-kit/websocket/use-websocket-connection';

interface FourthlineWebsocketProps {
  websocketToken: string;
  userId: string;
  onError: (payload: unknown) => void;
  onProcessFinished: (payload: unknown) => void;
}

export function FourthlineWebsocket({
  websocketToken,
  userId,
  onError,
  onProcessFinished,
}: FourthlineWebsocketProps) {
  const { urls } = useConfig();

  useQontoWebsocketConnection({
    websocketBaseURL: urls.websocketBaseURL,
    token: websocketToken,
    userId,
  });

  const memoizedOnError = useCallback(
    (payload: unknown) => {
      onError(payload);
    },
    [onError]
  );

  const memoizedOnProcessFinished = useCallback(
    (payload: unknown) => {
      onProcessFinished(payload);
    },
    [onProcessFinished]
  );

  useQontoWebsocket('error', memoizedOnError);
  useQontoWebsocket('process_finished', memoizedOnProcessFinished);

  return null;
}
